import { defaultTo } from 'lodash';
import {
  IRxSKUItemQuantityModel,
  RxSKUItemQuantityModel,
} from '@common/models/RxSKUItemQuantityModel';

export interface IRxSKUItemModel {
  rxSKUItemId: number;
  sourceSystemId: number;
  sourceSystemKey: string;
  packageName: string;
  sourceSystemName: string;
  quantities: IRxSKUItemQuantityModel[];
}

export class RxSKUItemModel {
  rxSKUItemId: number;
  sourceSystemId: number;
  sourceSystemKey: string;
  packageName: string;
  sourceSystemName: string;
  quantities: IRxSKUItemQuantityModel[];

  constructor(params?: Partial<IRxSKUItemModel>) {
    this.rxSKUItemId = defaultTo(params?.rxSKUItemId, 0);
    this.sourceSystemId = defaultTo(params?.sourceSystemId, 0);
    this.sourceSystemKey = defaultTo(params?.sourceSystemKey, '');
    this.packageName = defaultTo(params?.packageName, '');
    this.sourceSystemName = defaultTo(params?.sourceSystemName, '');

    this.quantities = defaultTo(params?.quantities, []).map(
      (q) => new RxSKUItemQuantityModel(q),
    );
  }
}
